'use client';

import { createContext } from 'react';

import type { ProgressStepperRootContextInterface } from '../types/progress-stepper-root.types';

export const ProgressStepperRootContext = createContext<ProgressStepperRootContextInterface>({
  activeStepIndex: 0,
  labelAppearance: { base: 'current', md: 'all' },
  steps: [],
});

ProgressStepperRootContext.displayName = 'ProgressStepper.Root.Context';
